module.exports = __webpack_public_path__ + "static/simple-b29f09205456ca17e479ad901c3d8fe8.png";